import type { ColumnFiltersState } from '@tanstack/react-table'
import isEqual from 'lodash/isEqual'

export const TEXT_FILTER_COMMIT_DEBOUNCE_MS = 400

export function hasTextValueChange(
  prev: ColumnFiltersState,
  next: ColumnFiltersState
): boolean {
  return hasFilterValueChange(prev, next, (value) => typeof value === 'string')
}

export function hasNonTextValueChange(
  prev: ColumnFiltersState,
  next: ColumnFiltersState
): boolean {
  return hasFilterValueChange(prev, next, Array.isArray)
}

function hasFilterValueChange(
  prev: ColumnFiltersState,
  next: ColumnFiltersState,
  isTargetValue: (
    value: ColumnFiltersState[number]['value'] | undefined
  ) => boolean
): boolean {
  const prevById = new Map(prev.map(({ id, value }) => [id, value]))
  const nextById = new Map(next.map(({ id, value }) => [id, value]))
  const ids = new Set([...prevById.keys(), ...nextById.keys()])
  for (const id of ids) {
    const prevValue = prevById.get(id)
    const nextValue = nextById.get(id)
    if (isEqual(prevValue, nextValue)) continue
    if (isTargetValue(prevValue) || isTargetValue(nextValue)) {
      return true
    }
  }
  return false
}
